import React from 'react';
import PropTypes from 'prop-types';
import './CustomizeImage.scss';

const CustomizeImage = ({ imageUrl, title, subtitle }) => {
  return (
    <div className="background-container" style={{ backgroundImage: `url(${imageUrl})` }}>
      <div className="overlay-text">
        <div className="title">{title}</div>
        <div className="subtitle">{subtitle}</div>
      </div>
    </div>
  );
};
CustomizeImage.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired
};
export default CustomizeImage;
